<template>
    <v-flex xs12 lg12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-flex xl12>
                    <v-layout wrap>
                        <v-btn flat class="primary" router :to="'/news/add'">Adicionar</v-btn>
                        <v-spacer></v-spacer>
                        <v-text-field @input="getDataFromApi" append-icon="search" label="Procurar" single-line hide-details v-model="search"></v-text-field>
                    </v-layout>
                </v-flex>
                <v-data-table flat
                              :headers="headers"
                              :items="registries"
                              :rows-per-page-text="'Registros por página '"
                              :no-data-text="'Sem registros'"
                              :pagination.sync="pagination"
                              :total-items="totalRegistries"
                              :loading="loading"
                              class="elevation-0"
                >
                    <template v-slot:items="props">
                            <tr>
                                <td width="5" class="text-xs-left">
                                   <v-img width="110" style="padding: 2px;margin: 4px;"
                                           :src="props.item.poster"
                                           aspect-ratio="1.0005"
                                           class="grey lighten-2 elevation-2"

                                   ></v-img>
                                </td>
                                <td class="text-xs-left" style="vertical-align: text-top">{{ props.item.title }}</td>
                                <td class="text-xs-left" style="vertical-align: text-top">{{ props.item.slug }}</td>
                                <td class="text-xs-center" style="vertical-align: text-top">{{ props.item.created }}</td>
                                <td class="justify-center layout px-0" style="vertical-align: text-top">
                                    <v-tooltip left>
                                        <v-btn icon slot="activator" @click="doEdit(props.item)">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <span>Editar</span>
                                    </v-tooltip>

                                    <v-tooltip v-if="props.item.status=='S'" left>
                                        <v-btn icon slot="activator" flat color="success"
                                               @click.stop="doChange(props.item.id,'A')">
                                            <v-icon>check_circle</v-icon>
                                        </v-btn>
                                        <span>Ativar</span>
                                    </v-tooltip>

                                    <v-tooltip v-if="props.item.status=='A'" left>
                                        <v-btn icon slot="activator" flat color="warning"
                                               @click.stop="doChange(props.item.id,'S')">
                                            <v-icon>block</v-icon>
                                        </v-btn>
                                        <span>Bloquear</span>
                                    </v-tooltip>

                                    <v-tooltip left>
                                        <v-btn icon slot="activator" flat color="error"
                                               @click.stop="doChange(props.item.id,'D')">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <span>Excluir</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="50%">
            <v-card dark>
                <v-card-title class="headline">
                    <span style="font-size: 14px;">Tem certeza que deseja {{action.action_name}} este registro?</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red darken-1" flat @click.native="dialog = false">NÃO</v-btn>
                    <v-btn dark color="green darken-1" flat @click.native="change">SIM</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>
<script>
    export default {
        name: 'news-list',
        data() {
            return {
                success: false,
                error: false,
                dialog: false,
                loading: false,
                messages: '',
                search: '',
                action: {
                    action_name: '',
                    id: 0,
                    status: ''
                },
                totalRegistries: 0,
                registries: [],
                pagination: {rowsPerPage: 30, search: ''},
                headers: [
                    {text: 'Poster', value: 'name', align: 'left'},
                    {text: 'Título', value: 'title', align: 'left'},
                    {text: 'Slug', value: 'slug', align: 'left'},
                    {text: 'Cadastro', value: 'created', align: 'center'},
                    {text: 'Ações', value: '', align: 'center'}
                ]
            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true
            }
        },
        mounted() {
            this.getDataFromApi()
            this.$store.commit('setLoading', true)
        },
        methods: {
            doChange(row, status) {
                if (status == 'S') {
                    this.action.action_name = 'suspender'
                } else if (status === 'A') {
                    this.action.action_name = 'ativar'
                } else if (status === 'D') {
                    this.action.action_name = 'apagar'
                }
                this.action.id = row
                this.action.status = status
                this.dialog = true
            },
            change() {
                var self = this
                self.loading = true
                self.axios.post('/update-news.json', this.action, {
                    headers: {
                        'Authorization': this.$store.state.token
                    }
                }).then((response) => {
                    if (response.data.success === true) {
                        self.getDataFromApi()
                        self.dialog = self.loading = false
                    }
                })
            },
            doEdit(row) {
                localStorage.setItem('register', JSON.stringify(row))
                this.$router.push({name: 'news-edit'})
            },
            getDataFromApi() {
                var self = this
                var data = this.pagination
                data.search = this.search
                data.role = this.role
                self.loading = true
                self.axios.get('/list-news.json', {
                    params: {
                        data
                    },
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.registries = response.data.registries
                    self.totalRegistries = response.data.totalRegistries
                    self.loading = false
                })
            }
        }
    }
</script>
